export class Door extends Phaser.Physics.Arcade.Image {
	locked:boolean;
	cost: number;
	spent: number;
	flagID:string;
	text: Phaser.GameObjects.Text;
	constructor(scene: Phaser.Scene, x: number, y: number) {
		super(scene, x, y, "sprites", "rock.png");
		this.text = scene.add.text(x,y-32,"",{ fontFamily: "Arial", fontSize: 16, color: "#00ff00" });
	}

	create(x: number, y: number, lock: boolean, cost: number, id: string): void {
		this.body.immovable = true;
		this.flagID = id;
		this.x = x;
		this.y = y;
		this.locked = lock;
		this.cost = cost;
		this.spent = 0;
		this.text.setPosition(this.x,this.y-32);
	}

	update(time: number, delta: number): void {
		// if(this.spent >= this.cost) {
		// 	this.text.destroy();
		// 	this.destroy();
		// }
	}

	afford(money: number): boolean {
		if(money >= this.cost - this.spent) {
			return true;
		}
		return false;
	}

	showCost(): void {
		this.text.setText(`¥${this.cost}`);
	}

	hideCost(): void {
		this.text.setText(``);
	}

	buy(): number {
		if(this.spent === this.cost) {
			return 0;
		}
		this.spent = this.cost;
		return this.cost;
	}
}
